import { Group, Text } from "@mantine/core";
import type * as React from "react";
import { PANEL_SPACE } from "./tokens";

/** The label column of a details card (Figma 15187:6107: "Company Name", "Colors"). */
const LABEL_WIDTH = 130;

/**
 * One row of a details card (Home's Your Details and Brand Configuration): a semibold label,
 * then its value. Rows sit 8px apart in their card.
 */
export function DetailRow({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <Group gap={PANEL_SPACE.field} wrap="nowrap" align="center">
      <Text fw={600} w={LABEL_WIDTH} lh={1.25} style={{ flexShrink: 0 }}>
        {label}
      </Text>
      <div style={{ flex: 1, minWidth: 0 }}>{children}</div>
    </Group>
  );
}

/** A small inline link after a value, its brackets part of the link: "Daniel Corp (Edit)"
 * (Dan 2026-10-02). `children` is the link; its text carries the brackets. */
export function InlineEdit({ children }: { children: React.ReactNode }) {
  return (
    <Text span inherit>
      {" "}
      {children}
    </Text>
  );
}
